import { Carousel } from 'react-bootstrap';
import img1 from '../images/Slider 1webp.webp';
import img2 from '../images/Slider 2webp.webp';
import img3 from '../images/Slider 3webp.webp';
import img4 from '../images/Slider 4webp.webp';
import img5 from '../images/Slider 5webp.webp';
import img6 from '../images/Slider 6webp.webp';
import { ChevronLeft, ChevronRight } from 'lucide-react'; // optional, for custom icons

import '../css/CarouselComponent.css';

function CarouselComponent() {
    const slides = [
        {
            id: 1,
            image: img1,

        },
        {
            id: 2,
            image: img2,

        },

        {
            id: 3,
            image: img3,

        },

        {
            id: 4,
            image: img4,

        },
        {
            id: 5,
            image: img5,

        },
        {
            id: 6,
            image: img6,

        },
    ];

    return (
        <Carousel interval={3000} fade={true} pause="hover" indicators={true} controls={true} // <-- enables left/right buttons
            prevIcon={<ChevronLeft size={30} color="#000" />} // custom prev icon
            nextIcon={<ChevronRight size={30} color="#000" />} // custom next icon
        >
            {slides.map((slide) => (
                <Carousel.Item key={slide.id} className="carousel-item">
                    {/* Background Image */}

                    <div className="carousel-images-home">
                        <img src={slide.image} alt={`Slide ${slide.id}`} className="img-fluid w-100" loading="lazy"
                        />
                    </div>


                </Carousel.Item>
            ))}
        </Carousel>
    );
}

export default CarouselComponent;
